import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav-progress",
  role: "progressbar",
  "aria-label": "Загрузка страницы",
  "aria-busy": "true"
}

import { isNavigating } from '@/shared/lib/navigationProgress';

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalNavigationProgress',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nav-progress-fade" }, {
    default: _withCtx(() => [
      (_unref(isNavigating))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "nav-progress__bar" }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})